import { useContext, useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';

import {
  ListSubheader,
  alpha,
  Box,
  List,
  styled,
  Button,
  ListItem,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import { SidebarContext } from 'src/contexts/SidebarContext';

import DesignServicesTwoToneIcon from '@mui/icons-material/DesignServicesTwoTone';
import BrightnessLowTwoToneIcon from '@mui/icons-material/BrightnessLowTwoTone';
import MmsTwoToneIcon from '@mui/icons-material/MmsTwoTone';
import TableChartTwoToneIcon from '@mui/icons-material/TableChartTwoTone';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import BallotTwoToneIcon from '@mui/icons-material/BallotTwoTone';
import BeachAccessTwoToneIcon from '@mui/icons-material/BeachAccessTwoTone';
import EmojiEventsTwoToneIcon from '@mui/icons-material/EmojiEventsTwoTone';
import FilterVintageTwoToneIcon from '@mui/icons-material/FilterVintageTwoTone';
import HowToVoteTwoToneIcon from '@mui/icons-material/HowToVoteTwoTone';
import LocalPharmacyTwoToneIcon from '@mui/icons-material/LocalPharmacyTwoTone';
import RedeemTwoToneIcon from '@mui/icons-material/RedeemTwoTone';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import TrafficTwoToneIcon from '@mui/icons-material/TrafficTwoTone';
import CheckBoxTwoToneIcon from '@mui/icons-material/CheckBoxTwoTone';
import ChromeReaderModeTwoToneIcon from '@mui/icons-material/ChromeReaderModeTwoTone';
import WorkspacePremiumTwoToneIcon from '@mui/icons-material/WorkspacePremiumTwoTone';
import CameraFrontTwoToneIcon from '@mui/icons-material/CameraFrontTwoTone';
import DisplaySettingsTwoToneIcon from '@mui/icons-material/DisplaySettingsTwoTone';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import SummarizeIcon from '@mui/icons-material/Summarize';
//new imports
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';
import LiveTvOutlinedIcon from '@mui/icons-material/LiveTvOutlined';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import SubtitlesOutlinedIcon from '@mui/icons-material/SubtitlesOutlined';
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import Footer from 'src/components/Footer';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import EmailIcon from '@mui/icons-material/Email';
import ScreenshotMonitorIcon from '@mui/icons-material/ScreenshotMonitor';
import SubjectIcon from '@mui/icons-material/Subject';
import CampaignIcon from '@mui/icons-material/Campaign';
import StorageIcon from '@mui/icons-material/Storage';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import HomeIcon from '@mui/icons-material/Home';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import PeopleIcon from '@mui/icons-material/People'; 
import ProtectedRoute from 'src/components/Permissions/ProtectedRoute';
import { AdminPanelSettings } from '@mui/icons-material';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AppsIcon from '@mui/icons-material/Apps';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';

import ReceiptIcon from '@mui/icons-material/Receipt';  // Add this for Tax
import PaymentIcon from '@mui/icons-material/Payment';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';


const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(1)};

    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
    }
  }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: ${theme.colors.alpha.trueWhite[50]};
      padding: ${theme.spacing(0, 2.5)};
      line-height: 1.4;
    }

    @media (min-width: ${theme.breakpoints.values.lg}px) {
      .css-15kcqlx {
        display: inline-block  !important;;
      }
    }
`
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {

      .MuiListItem-root {
        padding: 1px 0;

        .MuiBadge-root {
          position: absolute;
          right: ${theme.spacing(3.2)};

          .MuiBadge-standard {
            background: ${theme.colors.primary.main};
            font-size: ${theme.typography.pxToRem(10)};
            font-weight: bold;
            text-transform: uppercase;
            color: ${theme.palette.primary.contrastText};
          }
        }
    
        .MuiButton-root {
          display: flex;
          color: ${theme.colors.alpha.trueWhite[70]};
          background-color: transparent;
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(1.2, 3)};

          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(['color'])};

          
          }

          .MuiButton-startIcon {
            color: ${theme.colors.alpha.trueWhite[30]};
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(1)};
          }
          
          .MuiButton-endIcon {
            color: ${theme.colors.alpha.trueWhite[50]};
            margin-left: auto;
            opacity: .8;
            font-size: ${theme.typography.pxToRem(20)};
          }

          &.active,
          &:hover {
            background-color: ${alpha(theme.colors.alpha.trueWhite[100], 0.06)};
            color: ${theme.colors.alpha.trueWhite[100]};

            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.colors.alpha.trueWhite[100]};
            }
          }
        }

        &.Mui-children {
          flex-direction: column;

          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(7)};
          }
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiListItem-root {
            padding: 1px 0;

            .MuiButton-root {
              padding: ${theme.spacing(0.8, 3)};

              .MuiBadge-root {
                right: ${theme.spacing(3.2)};
              }

              &:before {
                content: ' ';
                background: ${theme.colors.alpha.trueWhite[100]};
                opacity: 0;
                transition: ${theme.transitions.create([
    'transform',
    'opacity'
  ])};
                width: 6px;
                height: 6px;
                transform: scale(0);
                transform-origin: center;
                border-radius: 20px;
                margin-right: ${theme.spacing(1.8)};
              }

              &.active,
              &:hover {

                &:before {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
`
);

function SidebarMenu() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [showText, setShowText] = useState(false); // State to toggle between icon-only and text-and-icon view
  const { sidebarToggle, toggleSidebar,hidesidebar,hidesdebarformobile } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const toggleMenu = () => {
    setShowText(!showText);
  };
  const [fingerprintOpen, setFingerprintOpen] = useState(false);
  const [franchiseOpen, setFranchiseOpen] = useState(false);
  const [fingerprintReportOpen, setFingerprintReportOpen] = useState(false);
  const [reconciliation, setReconciliation] = useState(false);
  const [modulesOpen, setModulesOpen] = useState(false);
  const [paymentsOpen, setPaymentsOpen] = useState(false);
  const [usersubscriber, setUsersubscriber] = useState(false);
  const [PaymentHistory, setPaymentHistoryList] = useState(false);

  const [manageTaxOpen, setManageTaxOpen] = useState(false);
   // 👇 Get user role from localStorage
  const accountType = localStorage.getItem('accountType');
  const appIntegrations = localStorage.getItem('appIntegrations');
  const appIntegrationsList: string[] = appIntegrations ? JSON.parse(appIntegrations) : [];
  //console.log("appIntegrationsList--", appIntegrationsList)
  // helper function for role check
  const hasPermission = (allowedRoles: string[]) => {
      // 👇 Get permissions from localStorage
    const storedPermissions = localStorage.getItem("permissions");
    const permissions: string[] = storedPermissions ? JSON.parse(storedPermissions) : [];
    return allowedRoles.some(role => permissions.includes(role));
  };

  return (
    <>
      <MenuWrapper >
        {/* OTT Menu Items Starts Here */}
        <List component="div">
          {/* Dashboard → access OWNER, User & Subscriber */}
          {(
            <SubMenuWrapper>
              <List component="div">

                {/* SHOW ONLY FOR OWNER */}
                {accountType === "OWNER" && (
                  <ListItem component="div">
                    <Button
                      disableRipple
                      startIcon={<DashboardIcon />}
                      to="/ott/dashboard"
                      component={RouterLink}
                      onClick={() => {
  if (isMobile) hidesdebarformobile();
}}
                    >
                      {!sidebarToggle ? 'Dashboard' : ''}
                    </Button>
                  </ListItem>
                )}

                {/* SHOW ONLY FOR OPERATOR */}
                {accountType !== "OWNER" && (
                  <ListItem component="div">
                    <Button
                      disableRipple
                      startIcon={<DashboardIcon />}
                      to="/ott/franchise-dashboard"
                      component={RouterLink}
                    >
                      {!sidebarToggle ? 'Dashboard' : ''}
                    </Button>
                  </ListItem>
                )}

              </List>
            </SubMenuWrapper>
          )}

           {/* {hasPermission(["OWNER","dashboard.index", "dashboard.create", "dashboard.edit","dashboard.delete" ]) && (
          <SubMenuWrapper>
            <List component="div" >
              <ListItem component="div">
                <Button
                  disableRipple
                  startIcon={<DashboardIcon />}
                  to='/ott/dashboard'
                  component={RouterLink}
                >
                { !sidebarToggle ? 'Dashboard' :''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )} */}

          

          



          {/* New Modules Section - Simple menu item */}
         {/* {hasPermission(["OWNER", "Admin"]) && (
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    startIcon={<AppsIcon />}
                    endIcon={modulesOpen ? <ExpandLess /> : <ExpandMore />}
                    onClick={() => setModulesOpen(!modulesOpen)}
                  >
                    {!sidebarToggle ? 'On-Board Config' : ''}
                  </Button>
                </ListItem>
                <Collapse in={modulesOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    

                    <ListItem component="div">
                      <Button
                        disableRipple
                        startIcon={<ManageAccountsIcon />}
                        to='/vendors/vendorDetails'
                        component={RouterLink}
                      >
                        {!sidebarToggle ? 'Vendors' : ''}
                      </Button>
                    </ListItem>

                    <ListItem component="div">
                      <Button
                        disableRipple
                        startIcon={<GpsFixedIcon />}
                        to='/modules/Locations'
                        component={RouterLink}
                      >
                        {!sidebarToggle ? 'Locations' : ''}
                      </Button>
                    </ListItem>

                    <ListItem component="div">
                      <Button
                        disableRipple
                        startIcon={<ManageAccountsIcon />}
                        to='/modules/OwnerAccounts'
                        component={RouterLink}
                      >
                        {!sidebarToggle ? 'Owner Accounts' : ''}
                      </Button>
                    </ListItem>

                    <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                      <Button
                        disableRipple
                        component={RouterLink}
                        to="/modules/modules"
                        startIcon={<AppsIcon />}
                        sx={{ pl: sidebarToggle ? 1 : 4 }}
                      >
                        {!sidebarToggle ? 'Modules List' : ''}
                      </Button>
                    </ListItem>

                    <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                      <Button
                        disableRipple
                        component={RouterLink}
                        to="/modules/permissions"
                        startIcon={<AppsIcon />}
                        sx={{ pl: sidebarToggle ? 1 : 4 }}
                      >
                        {!sidebarToggle ? 'Permissions List' : ''}
                      </Button>
                    </ListItem>

                    <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                      <Button
                        disableRipple
                        component={RouterLink}
                        to="/modules/applications-modules"
                        startIcon={<AppsIcon />}
                        sx={{ pl: sidebarToggle ? 1 : 4 }}
                      >
                        {!sidebarToggle ? 'App Modules' : ''}
                      </Button>
                    </ListItem>

                    <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                      <Button
                        disableRipple
                        component={RouterLink}
                        to="/modules/ThirdPartyApps"
                        startIcon={<AppSettingsAltIcon />}
                        sx={{ pl: sidebarToggle ? 1 : 4 }}
                      >
                        {!sidebarToggle ? 'ThirdPartyApps' : ''}
                      </Button>
                    </ListItem>

                    <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                      <Button
                        disableRipple
                        component={RouterLink}
                        to="/modules/permissions-modules"
                        startIcon={<AppsIcon />}
                        sx={{ pl: sidebarToggle ? 1 : 4 }}
                      >
                        {!sidebarToggle ? 'App Module Permissions' : ''}
                      </Button>
                    </ListItem>

                    
                    
                  </List>
                </Collapse>
              </List>
            </SubMenuWrapper>
          )}  */}  
           
          {/* Servers → only OWNER & Admin */}
          {hasPermission(["OWNER", "Admin","server.index", "server.create", "server.edit","server.delete" ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  startIcon={<StorageIcon />}
                  to='/ottserverspanel/Servers'
                  component={RouterLink}
                  onClick={() => {
  if (isMobile) hidesdebarformobile();
}}
                >
                  {!sidebarToggle ? 'Servers' : ''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )} 

          {hasPermission(["OWNER", "Admin","importDataFiles.index", "importDataFiles.create", "importDataFiles.edit","importDataFiles.delete" ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  startIcon={<LabelImportantIcon />}
                  to='/importDataFiles/imports'
                  component={RouterLink}
                  onClick={() => {
  if (isMobile) hidesdebarformobile();
}}
                >
                  {!sidebarToggle ? 'importDataFiles' : ''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )} 



          {/* {hasPermission(["OWNER"]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  startIcon={<AppSettingsAltIcon />}
                  to='/Thirdparty/ThirdPartyApps'
                  component={RouterLink}
                  onClick={() => {
  if (isMobile) hidesdebarformobile();
}}
                >
                  {!sidebarToggle ? 'Third-Party Apps' : ''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )} 
 */}
          {/* watcho */}
          {hasPermission(["OWNER", "Admin"]) && appIntegrationsList.includes('WATCHO') && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  startIcon={<AppSettingsAltIcon />}
                  to='/ottwatcho/watcho'
                  component={RouterLink}
                  onClick={() => {
  if (isMobile) hidesdebarformobile();
}}
                >
                  {!sidebarToggle ? 'Watcho' : ''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )} 

          {/* AreaPriceList */}
          {/*  {hasPermission(["OWNER"]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  startIcon={<LocalOfferIcon/>}
                  to='/areapricelist/AreaPriceList'
                  component={RouterLink}
                >
                  {!sidebarToggle ? 'AreaPriceList' : ''}
                </Button>
              </ListItem>
              
            </List>
          </SubMenuWrapper>
          )}  */}



          {/* {hasPermission(["OWNER"]) && (
            <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  to="/ApplicationConfig/ApplicationConfig"
                  startIcon={<BarChartOutlinedIcon />}
                >
                  { !sidebarToggle ? 'Application Config' :''}
                </Button>
              </ListItem>
             
            </List>
          </SubMenuWrapper>
          )} */}
          


          {/* Subscribers → OWNER & User */}
          {/* {hasPermission(["OWNER", "subscriber.index", "subscriber.create", "subscriber.edit","subscriber.delete"]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <ProtectedRoute
                  element={<Button
                  disableRipple
                  startIcon={<PeopleOutlined />}
                  to='/ottUserPanle/userpanel'
                  component={RouterLink}
                  onClick={() => {
  if (isMobile) hidesdebarformobile();
}}
                >
                   { !sidebarToggle ? 'Subscribers' :''}
                </Button>}
                  allowedRoles={["OWNER", "subscriber.index", "subscriber.create", "subscriber.edit","subscriber.delete"]}
                />
              </ListItem>
              <ListItem component="div">
                <ProtectedRoute
                  element={<Button
                  disableRipple
                  startIcon={<PeopleOutlined />}
                  to='/ottUserPanle/multiplesubscriptions'
                  component={RouterLink}
                  onClick={() => {
  if (isMobile) hidesdebarformobile();
}}
                >
                   { !sidebarToggle ? 'Multiple Subscriptions' :''}
                </Button>}
                  allowedRoles={["OWNER", "subscriber.index", "subscriber.create", "subscriber.edit","subscriber.delete"]}
                />
              </ListItem>
            </List>
          </SubMenuWrapper>
          )}
 */}
          {/* USER SUBSCRIPTION */}
          {hasPermission(["OWNER", "subscriber.index", "subscriber.create", "subscriber.edit","subscriber.delete"]) && (
            <SubMenuWrapper>
              <List component="div">
                {/* Parent Button */}
                <ListItem component="div">
                  <Button
                    disableRipple
                    startIcon={<PeopleOutlined />}
                    endIcon={usersubscriber ? <ExpandLess /> : <ExpandMore />}
                    onClick={() => setUsersubscriber(!usersubscriber)}
                  >
                    {!sidebarToggle ? "Subscribers" : ""}
                  </Button>
                </ListItem>

                {/* Dropdown List */}
                <Collapse in={usersubscriber} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>

                    {/* Subscriber Payments */}
                    {hasPermission(["OWNER", "subscriber.index", "subscriber.create", "subscriber.edit","subscriber.delete"]) && (
                      <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                        <Button
                          disableRipple
                          component={RouterLink}
                          to="/ottUserPanle/userpanel"
                          startIcon={<PeopleOutlined />}
                          sx={{ pl: sidebarToggle ? 1 : 4 }}
                        >
                          {!sidebarToggle ? "Subscriber" : ""}
                        </Button>
                      </ListItem>
                    )}

                    {/* multiple subscription */}
                    {hasPermission(["OWNER", "subscriber.index", "subscriber.create", "subscriber.edit","subscriber.delete"]) && (
                      <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                        <Button
                          disableRipple
                          component={RouterLink}
                          to="/ottUserPanle/multiplesubscriptions"
                          startIcon={<PeopleOutlined />}
                          sx={{ pl: sidebarToggle ? 1 : 4 }}
                        >
                          {!sidebarToggle ? "Multiple Subscriptions" : ""}
                        </Button>
                      </ListItem>
                    )}

                    {/* Blocked subscribers */}
                    {hasPermission(["OWNER", "subscriber.index", "subscriber.create", "subscriber.edit","subscriber.delete"]) && (
                      <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                        <Button
                          disableRipple
                          component={RouterLink}
                          to="/ottusers/BlockListedUsers"
                          startIcon={<PeopleOutlined />}
                          sx={{ pl: sidebarToggle ? 1 : 4 }}
                        >
                          {!sidebarToggle ? "Blocked Subscriptions" : ""}
                        </Button>
                      </ListItem>
                    )}

                    
                    
                  </List>
                </Collapse>
              </List>
            </SubMenuWrapper>
          )}

          

          {/* Content → OWNER & User only  */}
          {/* Content → OWNER & permitted users */}

          {/* expired subcription */}

          {/* <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  to="/ottusers/ExpiredSubcriptionList"
                  startIcon={<PeopleOutlined />}
                >
                  {!sidebarToggle ? 'Expiring subcribers' : ''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper> */}
          
{
  hasPermission([
    "OWNER",
    "category.index", "category.create", "category.edit", "category.delete",
    "broadcaster.index", "broadcaster.create", "broadcaster.edit","broadcaster.delete",
    "channel.index", "channel.create", "channel.edit", "channel.delete",
    "vod.index", "vod.create", "vod.edit","vod.delete",
    "package.index", "package.create", "package.edit","package.delete",
    "package_channel_mapping.index", "package_channel_mapping.create", "package_channel_mapping.edit","package_channel_mapping.delete",
    "app.index", "app.create", "app.edit","app.delete",
    "youtube.index", "youtube.create", "youtube.edit","youtube.delete",
    "epg.index", "epg.create", "epg.edit","epg.delete"
  ]) && (
    <SubMenuWrapper>
      <List component="div">
        <ListItem component="div">

          <ProtectedRoute
            element={
              (() => {
                const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");

                // Default (owner)
                let defaultPath = "/ottContentPanle/category";

                // Non-owner → choose first allowed tab
                if (!permissions.includes("OWNER")) {
                  if (permissions.includes("category.index")) defaultPath = "/ottContentPanle/category";
                  else if (permissions.includes("broadcaster.index")) defaultPath = "/ottContentPanle/broadcaster";
                  else if (permissions.includes("channel.index")) defaultPath = "/ottContentPanle/channel-setup";
                  else if (permissions.includes("vod.index")) defaultPath = "/ottContentPanle/vod";
                  else if (permissions.includes("package.index")) defaultPath = "/ottContentPanle/package";
                  else if (permissions.includes("package_channel_mapping.index")) defaultPath = "/ottContentPanle/package-mapping";
                  else if (permissions.includes("app.index")) defaultPath = "/ottContentPanle/app";
                  else if (permissions.includes("youtube.index")) defaultPath = "/ottContentPanle/youtube";
                  else if (permissions.includes("epg.index")) defaultPath = "/ottContentPanle/epg";
                }

                return (
                  <Button
                    disableRipple
                    startIcon={<SubjectIcon />}
                    to={defaultPath}
                    component={RouterLink}
                    onClick={() => {
  if (isMobile) hidesdebarformobile();
}}
                  >
                    {!sidebarToggle ? "Content" : ""}
                  </Button>
                );
              })()
            }

            allowedRoles={["OWNER", "category.index", "category.create", "category.edit","category.delete"
                                        , "broadcaster.index", "broadcaster.create", "broadcaster.edit","broadcaster.delete",
                                          "channel.index", "channel.create", "channel.edit", "channel.delete",
                                          "vod.index", "vod.create", "vod.edit","vod.delete",
                                          "package.index", "package.create", "package.edit","package.delete",
                                          "package_channel_mapping.index", "package_channel_mapping.create",
                                          "app.index", "app.create", "app.edit","app.delete",
                                          "youtube.index", "youtube.create", "youtube.edit","youtube.delete",
                                          "epg.index", "epg.upload"
                                 ]}
 
          />

        </ListItem>
      </List>
    </SubMenuWrapper>
  )
}


          {/* Advertisement → OWNER only */}
          {hasPermission([
              "OWNER",
              "advertisement.index", 
              "advertisement.create", 
              "advertisement.edit", 
              "advertisement.delete"
            ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <ProtectedRoute
                element={<Button
                  disableRipple
                  component={RouterLink}
                  to="/Advertisement"
                  startIcon={<CampaignIcon />}
                  onClick={() => {
  if (isMobile) hidesdebarformobile();
}}
                >
                  { !sidebarToggle ? 'Advertisement' :''}
                </Button>}
                allowedRoles={["OWNER", "advertisement.index", "advertisement.create", "advertisement.edit", "advertisement.delete"]}
                />
              </ListItem>
            </List>
          </SubMenuWrapper>
          )}

          {/* User Subscriptions → All roles */}
          {/* {
            hasPermission([
                "OWNER", 
                "user_subscription.index", 
                "user_subscription.create", 
                "user_subscription.edit", 
                "user_subscription.delete"
            ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  to="/ottsubscriptions/userSubscriptions"
                  startIcon={<SubscriptionsOutlinedIcon />}
                >
                   { !sidebarToggle ? 'User Subscriptions' :''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )} */}

          {/* Fingerprint → OWNER only */}
          {/* {hasPermission([
            "OWNER",
            "fingerprint.index",
            "fingerprint.create",
            "fingerprint.edit",
            "fingerprint.delete"
          ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  to="/ottfingerprint/fingerprint"
                  startIcon={<FingerprintIcon />}
                  endIcon={fingerprintOpen ? <ExpandLess /> : <ExpandMore />}
                  onClick={() => setFingerprintOpen(!fingerprintOpen)}
                >
                  {!sidebarToggle ? 'Fingerprint' : ''}
                </Button>
              </ListItem>
              <Collapse in={fingerprintOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottfingerprint/global-fingerprint"
                      startIcon={<FingerprintIcon />}
                      sx={{ pl: sidebarToggle ? 1 : 4 }}
                    >
                      {!sidebarToggle ? 'Global FingerPrint' : ''}
                    </Button>
                  </ListItem>
                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottfingerprint/channel-fingerprint"
                      startIcon={<FingerprintIcon />}
                      sx={{ pl: sidebarToggle ? 1 : 4 }}
                    >
                      {!sidebarToggle ? 'Channel FingerPrint' : ''}
                    </Button>
                  </ListItem>
                 <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottfingerprint/forensicFingerprintScreen"
                      startIcon={<FingerprintIcon />}
                      sx={{ pl: sidebarToggle ? 1 : 4 }}
                    >
                      {!sidebarToggle ? 'Forensic FingerPrint' : ''}
                    </Button>
                  </ListItem>
                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottfingerprint/fingerprints"
                      startIcon={<FingerprintIcon />}
                      sx={{ pl: sidebarToggle ? 1 : 4 }}
                    >
                      {!sidebarToggle ? 'fingerprints' : ''}
                    </Button>
                  </ListItem>
                </List>
              </Collapse>
            </List>
          </SubMenuWrapper>
          )} */}

          {hasPermission([
            "OWNER",
            "fingerprint.index",
            "fingerprint.create",
            "fingerprint.edit",
            "fingerprint.delete"
          ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  to="/ottfingerprint/fingerprints"
                  startIcon={<FingerprintIcon />}

                >
                  {!sidebarToggle ? 'Fingerprints' : ''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )}

          {/* {hasPermission([
            "OWNER"
          ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  to="/CustomerTickets/SubscriberTickets"
                  startIcon={<ConfirmationNumberIcon />}
                >
                  {!sidebarToggle ? 'Subscriber Tickets' : ''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )} */}

          {/* FranchiseLocations */}
         {/*  {hasPermission([
            "OWNER"
          ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  to="/FranchiseLocations"
                  startIcon={<GpsFixedIcon />}
                >
                  {!sidebarToggle ? 'Franchise Locations' : ''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )} */}

          {/* Franchise dropdown */}
          {hasPermission([
            "OWNER",
            "franchise.index",
            "franchise.create",
            "franchise.edit",
            "franchise.delete"
          ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  to="/franchise"
                  startIcon={<StorefrontOutlinedIcon />}
                  onClick={() => setFranchiseOpen(!franchiseOpen)}
                >
                  {!sidebarToggle ? 'Franchise' : ''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )}

          {/* Schedules → OWNER only */}
          {hasPermission([
            "OWNER",
            "schedule.index",
            // "schedule.create",
            // "schedule.edit",
            // "schedule.delete"
          ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  to="/Schedules"
                  startIcon={<StorefrontOutlinedIcon />}
                >
                  {!sidebarToggle ? 'Schedules' : ''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )}

          {/* Company → OWNER only */}
          {hasPermission([
            "OWNER",
            "company.index",
            "company.create",
            "company.edit",
            "company.delete"
          ]) && (
           <SubMenuWrapper>
            <List component="div" >
              <ListItem component="div">
                <Button
                  disableRipple
                  startIcon={<BusinessOutlinedIcon />}
                  to='/Company'
                  component={RouterLink}
                >
                { !sidebarToggle ? 'Company' :''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )}
          
          {/* Operator → OWNER only */}
          {hasPermission([
            "OWNER",
            "operator.index",
            "operator.create",
            "operator.edit",
            "operator.delete"
          ]) && (
          <SubMenuWrapper>
            <List component="div" >
              <ListItem component="div">
                <Button
                  disableRipple
                  startIcon={< ManageAccountsOutlinedIcon />}
                  to='/Operator'
                  component={RouterLink}
                  onClick={() => {
  if (isMobile) hidesdebarformobile();
}}
                >
                { !sidebarToggle ? 'Operator' :''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )}

          {/* Payments Section (Dropdown Menu) */}
          {hasPermission(["OWNER", "DISTRIBUTOR", "payment.index"]) && (
            <SubMenuWrapper>
              <List component="div">
                {/* Parent Button */}
                <ListItem component="div">
                  <Button
                    disableRipple
                    startIcon={<RequestQuoteOutlinedIcon />}
                    endIcon={paymentsOpen ? <ExpandLess /> : <ExpandMore />}
                    onClick={() => setPaymentsOpen(!paymentsOpen)}
                  >
                    {!sidebarToggle ? "Payments" : ""}
                  </Button>
                </ListItem>

                {/* Dropdown List */}
                <Collapse in={paymentsOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>

                    {/* Subscriber Payments */}
                    {hasPermission(["OWNER", "payment.index"]) && (
                      <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                        <Button
                          disableRipple
                          component={RouterLink}
                          to="/ottpayments/payments"
                          startIcon={<RequestQuoteOutlinedIcon />}
                          sx={{ pl: sidebarToggle ? 1 : 4 }}
                        >
                          {!sidebarToggle ? "Subscriber Payments" : ""}
                        </Button>
                      </ListItem>
                    )}

                    {/* Franchise Payments - OWNER only */}
                    {hasPermission(["OWNER", "DISTRIBUTOR"]) && (
                      <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                        <Button
                          disableRipple
                          component={RouterLink}
                          to="/ottfranchisepayments/payments"
                          startIcon={<RequestQuoteOutlinedIcon />}
                          sx={{ pl: sidebarToggle ? 1 : 4 }}
                        >
                          {!sidebarToggle ? "Franchise Payments" : ""}
                        </Button>
                      </ListItem>
                    )}

                    {/* Payment Distribution - DISTRIBUTOR only */}
                    
                    {hasPermission(["OWNER", "LCO_WALLET_ACCESS"]) && (
                      <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                        <Button
                          disableRipple
                          component={RouterLink}
                          to="/paymentTransfer/PaymentHistoryList"
                          startIcon={<RequestQuoteOutlinedIcon />}
                          sx={{ pl: sidebarToggle ? 1 : 4 }}
                        >
                          {!sidebarToggle ? "Distribute To LCO" : ""}
                        </Button>
                      </ListItem>
                    )}
                  </List>
                </Collapse>
              </List>
            </SubMenuWrapper>
          )}

          {hasPermission([
            "OWNER",
            "DISTRIBUTOR",
            "LCO",
            "CommissionWalletTransactions.index"
          ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  to="/CommissionTranctions/CommissionWalletTransactions"
                  startIcon={<StorefrontOutlinedIcon />}
                  onClick={() => setFranchiseOpen(!franchiseOpen)}
                >
                  {!sidebarToggle ? 'Commission Transactions' : ''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper>
          )}

          

          {/* Manage Tax → OWNER only */}
{hasPermission(["OWNER", "tax.index", "billing_tax_type.index"]) && (
  <SubMenuWrapper>
    <List component="div">
      <ListItem component="div">
        <Button
          disableRipple
          startIcon={<ReceiptIcon />}
          endIcon={manageTaxOpen ? <ExpandLess /> : <ExpandMore />}
          onClick={() => setManageTaxOpen(!manageTaxOpen)}
        >
          {!sidebarToggle ? 'Manage Tax' : ''}
        </Button>
      </ListItem>
      <Collapse in={manageTaxOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          
          {/* Tax */}
          <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
            <Button
              disableRipple
              component={RouterLink}
              to="/managetax/tax"
              startIcon={<ReceiptIcon />}
              sx={{ pl: sidebarToggle ? 2 : 4 }}
            >
              {!sidebarToggle ? 'Tax' : ''}
            </Button>
          </ListItem>

          {/* Manage Billing Tax Type */}
          <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
            <Button
              disableRipple
              component={RouterLink}
              to="/managetax/manage-billing-tax-type"
              startIcon={<PaymentIcon />}
              sx={{ pl: sidebarToggle ? 2 : 4 }}
            >
              {!sidebarToggle ? 'Manage Billing Tax Type' : ''}
            </Button>
          </ListItem>

        </List>
      </Collapse>
    </List>
  </SubMenuWrapper>
)}
          {/* {hasPermission(["OWNER", "DISTRIBUTOR", "payment.index"]) && (
            <SubMenuWrapper>
              <List component="div">
                {/* Parent Button *}
                <ListItem component="div">
                  <Button
                    disableRipple
                    startIcon={<RequestQuoteOutlinedIcon />}
                    endIcon={paymentsOpen ? <ExpandLess /> : <ExpandMore />}
                    onClick={() => setPaymentsOpen(!paymentsOpen)}
                  >
                    {!sidebarToggle ? "Payments" : ""}
                  </Button>
                </ListItem>

                {/* Dropdown List *}
                <Collapse in={paymentsOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>

                    {/* Subscriber Payments *}
                    <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                      <Button
                        disableRipple
                        component={RouterLink}
                        to="/ottpayments/payments"
                        startIcon={<RequestQuoteOutlinedIcon />}
                        sx={{ pl: sidebarToggle ? 1 : 4 }}
                      >
                        {!sidebarToggle ? "Subscriber Payments" : ""}
                      </Button>
                    </ListItem>

                    {/* Franchise Payments *}
                    <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                      <Button
                        disableRipple
                        component={RouterLink}
                        to="/ottfranchisepayments/payments"
                        startIcon={<RequestQuoteOutlinedIcon />}
                        sx={{ pl: sidebarToggle ? 1 : 4 }}
                      >
                        {!sidebarToggle ? "Franchise Payments" : ""}
                      </Button>
                    </ListItem>

                  </List>
                </Collapse>
              </List>
            </SubMenuWrapper>
          )} */}


           {/* {hasPermission(["DISTRIBUTOR", "PT.index","PaymentHistoryList.index"]) && (
            <SubMenuWrapper>
              <List component="div">
                {/* Parent Button *}
                <ListItem component="div">
                  <Button
                    disableRipple
                    startIcon={<RequestQuoteOutlinedIcon />}
                    endIcon={PaymentHistory ? <ExpandLess /> : <ExpandMore />}
                    onClick={() => setPaymentHistoryList(!PaymentHistory)}
                  >
                    {!sidebarToggle ? "PaymentTransfer" : ""}
                  </Button>
                </ListItem>

                {/* Dropdown List *}
                <Collapse in={PaymentHistory} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>

                    {/* Subscriber Payments */}
                    {/* <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                      <Button
                        disableRipple
                        component={RouterLink}
                        to="/paymentTransfer/PaymentTransfer"
                        startIcon={<RequestQuoteOutlinedIcon />}
                        sx={{ pl: sidebarToggle ? 1 : 4 }}
                      >
                        {!sidebarToggle ? "paymentTransfer" : ""}
                      </Button>
                    </ListItem> */}

                    {/* Franchise Payments *}
                    <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                      <Button
                        disableRipple
                        component={RouterLink}
                        to="/paymentTransfer/PaymentHistoryList"
                        startIcon={<RequestQuoteOutlinedIcon />}
                        sx={{ pl: sidebarToggle ? 1 : 4 }}
                      >
                        {!sidebarToggle ? "PaymentHistoryList" : ""}
                      </Button>
                    </ListItem>

                  </List>
                </Collapse>
              </List>
            </SubMenuWrapper>
          )} */}


          {/* Role → OWNER only*/}
          {hasPermission([
            "OWNER", 
            "roles.index", 
            "roles.create", 
            "roles.edit",
            "roles.delete"
          ]) && (
           <SubMenuWrapper>
            <List component="div" >
              <ListItem component="div">
                <Button
                  disableRipple
                  startIcon={<SupervisorAccountIcon />}
                  to='/Role/role'
                  component={RouterLink}
                >
                { !sidebarToggle ? 'Role' :''}
                </Button>
              </ListItem>
            </List>
          </SubMenuWrapper> 
          )}
          
          {/* Reports → OWNER only */}
          {hasPermission(["OWNER"]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  startIcon={<PeopleOutlined />}
                  endIcon={fingerprintReportOpen ? <ExpandLess /> : <ExpandMore />}
                  onClick={() => setFingerprintReportOpen(!fingerprintReportOpen)}
                >
                  {!sidebarToggle ? 'Reports' : ''}
                </Button>
              </ListItem>
              <Collapse in={fingerprintReportOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {/* ... (keep all your existing report items) */}

                   {/* <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/subscription-report"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '1. Subscription Report' : ''}
                    </Button>
                  </ListItem> */}

                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/TokenBasedReport"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'Token Report' : ''}
                    </Button>
                  </ListItem>

                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/UserDetailLogReport"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'Subscriber Detail Log' : ''}
                    </Button>
                  </ListItem>


                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/SubscriberPackageList"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '1 Subscriber Package Details' : ''}
                    </Button>
                  </ListItem>

                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/UserSubscriptionLogs"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '2 User Subscription Logs' : ''}
                    </Button>
                  </ListItem>

                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/package-channel-composition-report"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '3 Package Channel Composition Report' : ''}
                    </Button>
                  </ListItem>

                  
                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/package-channel-modification-report"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '4 Package Channel Modification Report' : ''}
                    </Button>
                  </ListItem>

                    <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/UserActivityLogs"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '5.User Activity Logs' : ''}
                    </Button>
                  </ListItem>

                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/monthlySubscriptionPackReport"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '6. package Subscription  Report (MSR)' : ''}
                    </Button>
                  </ListItem>

                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/alaCarteChannelMapReport"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '7. A-LA-CARTE Subscription Report' : ''}
                    </Button>
                  </ListItem>

                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/channelageing-report"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '8. Channel Ageing Report' : ''}
                    </Button>
                  </ListItem>

                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
            <Button
              disableRipple
              component={RouterLink}
              to="/ottreports/package-wise-ageing"
              startIcon={<SummarizeIcon />}
              sx={{ pl: sidebarToggle ? 2 : 4 }}
            >
              {!sidebarToggle ? '9. Package Ageing Report' : ''}
            </Button>
          </ListItem>

                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/STBActivationHistoryReports"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '10. STB Activation History Report' : ''}
                    </Button>
                  </ListItem>


                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/UniqueActivateSubscriberStbReports"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '11. Unique Active Subscriber STB Reports' : ''}
                    </Button>
                  </ListItem>



                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/packageActivationReport"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '12. Package Activation Report' : ''}
                    </Button>
                  </ListItem>

                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/ChannelActivationDeactivationHistoryReports"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '13. Channel Activation / De-Activation History Report' : ''}
                    </Button>
                  </ListItem>

                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/FingerPrintLogs"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '14. Fingerprint Logs' : ''}
                    </Button>
                  </ListItem>

                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/channelstatus-report"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '15. Channel Status Report' : ''}
                    </Button>
                  </ListItem>

                  
                  


                   
                 

                  

                  

                  

                   

                 

                  



                 

                    

                   

                    {/* <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/CustomeChannel-report"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'CustomeChannel report' : ''}
                    </Button>
                  </ListItem> */}

                  

                 

                  

                 

                  

                  {/* <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/drmevents-report"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'drmevents report' : ''}
                    </Button>
                  </ListItem> */}

                  

                   
                  
                  

                  {/* <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/KeysLogs"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '16. Key Rotation Logs' : ''}
                    </Button>
                  </ListItem>  */}


                   

                  

                  

                  {/* <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/Drm_conditional_report"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'Drm conditional Report' : ''}
                    </Button>
                  </ListItem> */}

                  {/* <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/DrmFingerprinting"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'Drm Finger printing' : ''}
                    </Button>
                  </ListItem> */}

                  {/*  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/DrmStbManagement"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'Drm Stb Management' : ''}
                    </Button>
                  </ListItem> */}

                  

                  

                  

                   

                    

                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/packageWiseSTBCountReport"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '16 package Wise STB Count Report' : ''}
                    </Button>
                  </ListItem>

                   

                  

                  {/* <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/packageactivationdetailsreport"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'package activation details report' : ''}
                    </Button>
                  </ListItem>

 */}
                    

                 

                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/OtalogReport"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '17 Ota Log Report' : ''}
                    </Button>
                  </ListItem>

                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/price-change-history"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '18 Price Change History' : ''}
                    </Button>
                  </ListItem>

                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/RefundPaymentReport"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '19 Refund Payment Report' : ''}
                    </Button>
                  </ListItem>
                  
                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/SubscriberMonthlyStatusReport"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '20 Subscriber Monthly Status Report' : ''}
                    </Button>
                  </ListItem>
                  

                   {/* <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/RedirectionLogs"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? '18 Redirection Logs' : ''}
                    </Button>
                  </ListItem> */}

                 
                   {/* <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/ottreports/BroadcasterReports"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'BroadcasterReports' : ''}
                    </Button>
                  </ListItem> */}
                    

                  

                  {/* ... (other report items) */}
                </List>
              </Collapse>
            </List>
          </SubMenuWrapper>
          )}

          {/* Reconciliation →  OWNER only*/}
          {hasPermission([
            "OWNER",
            "reconciliation.index",
            "reconciliation.create",
            "reconciliation.edit",
            "reconciliation.delete"
          ]) && (
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button
                  disableRipple
                  component={RouterLink}
                  to="/OTT-Reconciliation/Stb_Reconciliation"
                  startIcon={<PeopleOutlined />}
                  endIcon={reconciliation ? <ExpandLess /> : <ExpandMore />}
                  onClick={() => setReconciliation(!reconciliation)}
                >
                  {!sidebarToggle ? 'Reconciliation' : ''}
                </Button>
              </ListItem>
               <Collapse in={reconciliation} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>

                   <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/OTT-Reconciliation/Stb_Reconciliation"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'Stb_Reconciliation' : ''}
                    </Button>
                  </ListItem>

                    <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/OTT-Reconciliation/Package_Channel_Reconciliation"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'Package Channel Reconciliation' : ''}
                    </Button>
                  </ListItem>


                  <ListItem component="div" sx={{ pl: sidebarToggle ? 0 : 3 }}>
                    <Button
                      disableRipple
                      component={RouterLink}
                      to="/OTT-Reconciliation/Create_Reconciliation"
                      startIcon={<SummarizeIcon />}
                      sx={{ pl: sidebarToggle ? 2 : 4 }}
                    >
                      {!sidebarToggle ? 'Create_Reconciliation' : ''}
                    </Button>
                  </ListItem>
                  {/* ... (keep all your existing reconciliation items) */}
                </List>
              </Collapse>
            </List>
          </SubMenuWrapper>
          )}

          <SubMenuWrapper sx={{display:'flex',justifyContent:"center"}}>
            <Button onClick={toggleSidebar}>
              <MenuIcon/>
            </Button>
          </SubMenuWrapper>
        </List>
      </MenuWrapper>
      { !sidebarToggle ? <Footer/> : ''}
    </>
  );
}

export default SidebarMenu;